<template>
  <popup
    :opened="isDisplayed"
    @close="$emit('close')"
  >
    <!-- BEGIN Content modal ask confirmation to detach neopass -->
    <div v-if="state == 1">
      <div class="mx-12 items-center w-auto h-auto rounded-lg p-5">
        <h3 class="w-full  ">
          Détacher {{ neopassToDetach.firstname }} <span class="uppercase">{{ neopassToDetach.lastname }}</span> de la structure
        </h3>
        <div class="text-md text-indigo-600 font-normal text-center pt-8 pb-10">
          <div
            class="mb-5 text-pink-600"
            v-if="[neopassToDetach.has_evaluation_perso_in_progress, neopassToDetach.has_evaluation_pro_in_progress, neopassToDetach.has_evaluation_socio_pro_in_progress].filter(v => v === true).length > 0"
          >
            Des évaluations dans le<span v-if="[neopassToDetach.has_evaluation_perso_in_progress, neopassToDetach.has_evaluation_pro_in_progress, neopassToDetach.has_evaluation_socio_pro_in_progress].filter(v => v === true).length > 1">s</span>
            module<span v-if="[neopassToDetach.has_evaluation_perso_in_progress, neopassToDetach.has_evaluation_pro_in_progress, neopassToDetach.has_evaluation_socio_pro_in_progress].filter(v => v === true).length > 1">s</span>
            <span v-if="neopassToDetach.has_evaluation_perso_in_progress">compétences personnelles</span>
            <span
              v-if="neopassToDetach.has_evaluation_perso_in_progress && [neopassToDetach.has_evaluation_perso_in_progress, neopassToDetach.has_evaluation_pro_in_progress, neopassToDetach.has_evaluation_socio_pro_in_progress].filter(v => v === true).length === 2"
            >
              et
            </span>
            <span
              v-if="neopassToDetach.has_evaluation_perso_in_progress && [neopassToDetach.has_evaluation_perso_in_progress, neopassToDetach.has_evaluation_pro_in_progress, neopassToDetach.has_evaluation_socio_pro_in_progress].filter(v => v === true).length === 3"
            >
              ,
            </span>
            <span v-if="neopassToDetach.has_evaluation_socio_pro_in_progress">compétences socio-professionnelles</span>
            <span v-if="neopassToDetach.has_evaluation_pro_in_progress && neopassToDetach.has_evaluation_socio_pro_in_progress">et</span>
            <span v-if="neopassToDetach.has_evaluation_pro_in_progress">compétences professionnelles</span> sont en cours.
            <p>
              En détachant ce Neopass de votre structure, ces évaluations en cours seront supprimées.
            </p>
            <p>
              Seules les historiques seront conservés.
            </p>
          </div>
          <div>
            <span class="uppercase">ê</span>tes vous sûr de vouloir détacher le Neopass de {{ neopassToDetach.firstname }} <span class="uppercase">{{ neopassToDetach.lastname }}</span> de votre structure ?
          </div>
        </div>
        <div class="flex justify-center">
          <action-button
            class="p-3 font-normal"
            border-color="border-pink-600"
            text-color="text-pink-600"
            bg-color="bg-pink-300"
            libelle="ANNULER"
            @clickAction="$emit('close')"
          />
          <div class="ml-5">
            <action-button
              class="p-3 font-normal"
              border-color="border-transparent"
              text-color="text-white"
              bg-color="bg-pink-600"
              libelle="CONFIRMER"
              @clickAction="$emit('confirmDetach')"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- END Content modal ask confirmation to detach neopass -->

    <!-- BEGIN Content modal confirmation detachment -->
    <div v-if="state == 2">
      <div class="mx-5 xl:mx-24 items-center w-auto h-auto rounded-lg p-5">
        <h3 class="w-full   text-pink-600">
          Le Neopass de {{ neopassToDetach.firstname }} <span class="uppercase">{{ neopassToDetach.lastname }}</span> a bien été détaché de la structure
        </h3>
        <div class="w-full  flex justify-center">
          <illustration
            name="basket"
            class="w-full m-5"
          />
        </div>
      </div>
    </div>
    <!-- END Content modal confirmation detachment -->
  </popup>    
</template>

<script>
import Popup from './../Popup.vue';
import ActionButton from '../ActionButton.vue';
import Illustration from '../Illustration.vue';

export default {
  components:{
    Popup,
    ActionButton,
    Illustration
  },

  props:{
    isDisplayed:{
      type: Boolean,
      required: true,
    },

    state:{
      type: Number,
      required: true
    },

    neopassToDetach:{
      type: Object,
      required: true,
    }
  }
};
</script>